var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-icon',{attrs:{"small":"","color":_vm.color}},[_vm._v("icon-circle-fill")])
}
var staticRenderFns = []

export { render, staticRenderFns }